var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandwidth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "network_check"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3228_402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3228_402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "network_check_2",
    d: "M1.75 9.2487L0 7.4987C1.31944 6.15148 2.84375 5.12023 4.57292 4.40495C6.30208 3.68967 8.11111 3.33203 10 3.33203C10.3333 3.33203 10.6667 3.34245 11 3.36328C11.3333 3.38411 11.6667 3.41536 12 3.45703L10.75 5.8737C10.625 5.85981 10.5 5.84939 10.375 5.84245C10.25 5.8355 10.125 5.83203 10 5.83203C8.44444 5.83203 6.95486 6.12717 5.53125 6.71745C4.10764 7.30773 2.84722 8.15148 1.75 9.2487ZM5.29167 12.7904L3.54167 10.9987C4.33333 10.207 5.24306 9.58898 6.27083 9.14453C7.29861 8.70009 8.375 8.44314 9.5 8.3737L8.16667 11.1029C7.625 11.2556 7.11111 11.4744 6.625 11.7591C6.13889 12.0438 5.69444 12.3876 5.29167 12.7904ZM9.41667 16.5404C8.95833 16.3876 8.625 16.0994 8.41667 15.6758C8.20833 15.2522 8.20833 14.832 8.41667 14.4154L13.4167 4.2487C13.4722 4.13759 13.5556 4.06467 13.6667 4.02995C13.7778 3.99523 13.8889 3.9987 14 4.04036C14.1111 4.08203 14.1944 4.15495 14.25 4.25911C14.3056 4.36328 14.3194 4.47092 14.2917 4.58203L11.5833 15.5404C11.4722 15.9987 11.1979 16.3251 10.7604 16.5195C10.3229 16.714 9.875 16.7209 9.41667 16.5404ZM14.7083 12.7904C14.6111 12.6931 14.5174 12.6063 14.4271 12.5299C14.3368 12.4536 14.2361 12.3737 14.125 12.2904L14.7917 9.6862C15.0833 9.88064 15.3715 10.0855 15.6562 10.3008C15.941 10.5161 16.2083 10.7487 16.4583 10.9987L14.7083 12.7904ZM18.2292 9.26953C17.7847 8.86675 17.3299 8.48481 16.8646 8.1237C16.3993 7.76259 15.9028 7.44314 15.375 7.16536L15.9583 4.66536C16.7083 5.02648 17.4236 5.44314 18.1042 5.91536C18.7847 6.38759 19.4167 6.91536 20 7.4987L18.2292 9.26953Z",
    fill: "#89AFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandwidth);
export default __webpack_public_path__ + "static/media/bandwidth.b4d5b564a4f2d50e898b986c5c828fce.svg";
export { ForwardRef as ReactComponent };